import * as React from 'react'
import Common from './Common'
import styled from 'styled-components'

const linkEffect =
  '&:hover {  transform: scale(1.02, 1.02); }' +
  '&:focus {  transform: scale(1.02, 1.02); }' +
  '&:active { }' +
  '&:disabled { opacity: 0.3; transform: none; }'

const ReferenceList = styled.ul`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  list-style-type: none;
`

const ReferenceItem = styled.li`
  flex: 0 1 auto;
  width: calc(25% - 8px);

  a {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.default};
    font-weight: 600;
    font-size: ${({ theme }) => theme.fonts.largeSize};
    display: flex;
    flex-direction: column;
  }

  .illustration {
    height: 0;
    overflow: hidden;
    padding-top: calc(9 / 16 * 100%);
    background: white;
    position: relative;
  }

  .illustration img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  span {
    padding: 8px 0px;
  }

  margin-bottom: 15px;
`

const SeeMoreButton = styled.button`
  margin: 10px auto 0px;
  padding: 0;
  border: none;
  cursor: pointer;
  display: block;
  background-color: ${({ theme }) => theme.project.button.gray};

  a {
    text-decoration: none;
    width: 100%;
    height: 100%;
  }

  a .content {
    color: white;
    width: 100%;
    height: 100%;
    padding: 0.9em 4em;
    font-size: 0.8rem;
    font-weight: bolder;
  }

  ${linkEffect} &:hover {
    background: ${({ theme }) => theme.project.button.hover};
  }
`

const references = require('./references.json')

const References = () => (
  <Common>
    <h2 className="feature-title">References</h2>
    <ReferenceList>
      {references.items.map(ref => (
        <ReferenceItem key={ref.id}>
          <a href={ref.url} target="_blank">
            <div className="illustration">
              <img src={process.env.PUBLIC_URL + ref.imageUrl} />
            </div>
            <span>{ref.text}</span>
          </a>
        </ReferenceItem>
      ))}
    </ReferenceList>
    <SeeMoreButton>
      <a href={references.seeMoreLink} target="_blank">
        <div className="content">SEE MORE</div>
      </a>
    </SeeMoreButton>
  </Common>
)

export default References



// WEBPACK FOOTER //
// ./src/Components/Layout/Features/References.tsx